import React from 'react';
import { Link } from 'react-router-dom';


const BlogThree = () => {
    return(
        <>
        {/*Blog Section*/}
        <section className="blog-section section-padding-four">
            <div className="default-container">
            <div className="row clearfix">
                <div className="col-lg-12">
                <div className="sec-o-title text-center pb-3">
                    <h2 className="transform-uppercase">Latest <span>News</span></h2>
                </div>
                </div>
            </div>
            <div className="row clearfix">
                <div className="col-lg-4 mb-5">
                <div className="blog-cont-holder">
                    <div className="img_blog">
                    <img src="images/blog/bl-01-350x275.png" alt="" className="img-fluid mx-auto d-block" />
                    </div>
                    <div className="blog-box-detail p-4 text-center">
                    <div className="mt-0">
                        <p className="space-date">January 25</p>
                        <h5 className="font-weight-bold"><Link to="#">What to Look for In Your Health Insurance Policy</Link></h5>
                        <p>It is a long established fact that a reader will be distracted by the readable content</p>
                        <Link className="read-more text-uppercase font-weight-bold" to="single-post.html">Read More</Link>
                    </div>
                    </div>
                </div>
                </div>
                <div className="col-lg-4 mb-5">
                <div className="blog-cont-holder">
                    <div className="img_blog">
                    <img src="images/blog/bl-02-350x275.png" alt="" className="img-fluid mx-auto d-block" />
                    </div>
                    <div className="blog-box-detail p-4 text-center">
                    <div className="mt-0">
                        <p className="space-date">January 25</p>
                        <h5 className="font-weight-bold"><Link to="#">Understanding the IRS Trust Fund Recovery Penalty</Link></h5>
                        <p>It is a long established fact that a reader will be distracted by the readable content</p>
                        <Link className="read-more text-uppercase font-weight-bold" to="single-post.html">Read More</Link>
                    </div>
                    </div>
                </div>
                </div>
                <div className="col-lg-4 mb-5">
                <div className="blog-cont-holder">
                    <div className="img_blog">
                    <img src="images/blog/bl-03-350x275.png" alt="" className="img-fluid mx-auto d-block" />
                    </div>
                    <div className="blog-box-detail p-4 text-center">
                    <div className="mt-0">
                        <p className="space-date">January 25</p>
                        <h5 className="font-weight-bold"><Link to="#">The Insured Still Have Options for Denied Claims</Link></h5>
                        <p>It is a long established fact that a reader will be distracted by the readable content</p>
                        <Link className="read-more text-uppercase font-weight-bold" to="single-post.html">Read More</Link>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <div className="row clearfix">
                <div className="col-lg-12">
                <div className="button-box text-center">
                    <Link to="#" className="o-btn btn-style-ten">Load More</Link>
                </div>
                </div>
            </div>
            </div>
        </section>
        {/*End Blog Section*/}
        </>
    )
}

export default BlogThree;